import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../../../../components/default/DefaultModal';
import WarehouseQuoteExtraServiceDataTable from '../tables/WarehouseQuoteExtraServiceDataTable';
import { ServiceResponse } from '../../../../../../app/services/shared/interfaces';
import useSweetAlert from '../../../../../../hooks/useSweetAlert';
import useWarehouseQuoteExtraService from '../../../../../../app/services/hooks/useWareHouseQuoteExtraServicesService';
import {
    WarehouseExtraService,
    WarehouseExtraServiceFilters
} from '../../../../../../app/models/WareHouseQuoteExtraService';
import { ServiceDataForm, ServiceFilters } from '../../../../../../app/models/Service';
import ServiceCreate from '../../../../../Services/components/ServiceCreate';
import { WarehouseExtraServiceDataForm } from '../../../../../../app/models/WareHouseQuoteExtraService';
import ServiceDataTable from '../../../../../Services/components/tables/ServiceDataTable';
import WarehouseExtraServiceCreate from '../WarehouseExtraServiceCreate';
import WarehouseQuoteExtraServiceEdit from '../WarehouseExtraServiceEdit';
import WarehouseQuoteExtraServiceShow from '../WarehouseExtraServiceShow';
import { AppContext } from '../../../../../../contexts/AppContext';
import useReactConfirmAlert from '../../../../../../hooks/useReactConfirmAlert';

interface Props {
    quoteId: number;
    // expeditions: WarehouseExpeditionDataForm;
    disableUpdate?: boolean;
    refresh?: number;
    isFormShow?: boolean;

}
const WarehouseQuoteExtraServiceContainer = ({
    quoteId,
    disableUpdate = false,
    isFormShow = false,

    refresh
}: Props) => {
    const {
        getAllWarehouseExtraServicesByQuote,
        deleteWarehouseExtraService,
        storeWarehouseExtraService,
        fetchingGetWarehouseExtraServices
    } = useWarehouseQuoteExtraService();
    const [services, setServices] = useState<ServiceDataForm[]>([]);
    const [serviceFilter, setServiceFilter] = useState<ServiceFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'asc'
    });
    const [warehouseQuoteExtraServices, setWarehouseQuoteExtraServices] = useState<WarehouseExtraService[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseExtraServiceFilters>({ page: 1, per_page: 10, sort: 'id', order: 'desc' });
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);
    const [extraServiceIdEdit, setExtraServiceIdEdit] = useState<number>(-1);
    const [extraServiceIdShow, setExtraServiceIdShow] = useState<number>(-1);
    const [showingCreate, setShowingCreate] = useState(false);
    // const [extraServiceIdShow, setRateIdShow] = useState<number>(-1);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setExtraServiceIdEdit(id);
    };
    const showShow = (id: number) => {
        setShowingShow(true);
        setExtraServiceIdShow(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setExtraServiceIdEdit(-1);
    };
    const hideShow = () => {
        setShowingShow(false);
        setExtraServiceIdShow(-1);
    };

    const reloadTable = () => {
        getAllWarehouseExtraServicesByQuote(quoteId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseQuoteExtraServices(response.data.extra_service);
                setTotalRows(response.data.total_rows || 0);
            }
        });
    };

    // const destroy = (id: number) => {
    //     useSweetAlert().requestConfirmation({
    //         title: '¿Está seguro?',
    //         text: `Está a punto de eliminar el servicio adicional #${id}`,
    //         confirmButtonText: 'Sí, eliminar',
    //         cancelButtonText: 'Cancelar',
    //         onConfirm: () => {
    //             useSweetAlert().spinnerAlert('Eliminando...', 400);
    //             deleteWarehouseExtraService(id, {
    //                 onSuccess: () => {
    //                     toast.success('Eliminado con éxito');
    //                     reloadTable();
    //                 },
    //                 onError: (res) => toast.error(res.message)
    //             });
    //         }
    //     });
    // };

        const destroy = (id: number) => {
        const message = `Está a punto de eliminar el servicio adicional #${id}`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: message,
            buttons: {
                confirmButton: {
                    label: 'Sí, eliminar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando almacenamiento...');
                        
                        deleteWarehouseExtraService(id, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El almacenamiento no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    useEffect(() => {
        if (quoteId) reloadTable();
    }, [quoteId, filter, refresh]);

    return (
        <>
            <DefaultCard>
                <div className="h3 mt-0 mb-4 card-title">Servicos Adicionales</div> 
                <div className="row">
                    <div className="col-12">
                        {!disableUpdate && (
                            <DefaultToolBar left={<ButtonCreate callbackCreate={() => setShowingCreate(true)} />} />
                        )}
                    </div>
                    <div className="col-12">
                    <WarehouseQuoteExtraServiceDataTable
                        warehouseQuoteExtraServices={warehouseQuoteExtraServices}
                        totalRows={totalRows}
                        loading={fetchingGetWarehouseExtraServices}
                        destroy={destroy}
                        show={showShow}
                        edit={showEdit}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={isFormShow}

                    />
                    </div>
                </div>
            </DefaultCard>

            {showingCreate ? (

            <DefaultModal
                show={showingCreate}
                handleClose={() => setShowingCreate(false)}
                title="Crear Servicio Adicional"
                showFooter={false}
            >
                <WarehouseExtraServiceCreate
                    quoteId={quoteId}
                    onSaved={() => {
                        reloadTable();
                        setShowingCreate(false);
                    } }
                    onCancel={() => setShowingCreate(false)}
                    onError={() => setShowingCreate(false)}  
                    />
            </DefaultModal>

            ) : null}

            {showingEdit ? (
            <DefaultModal
                show={showingEdit}
                handleClose={hideEdit}
                title="Editar día libre"
                showFooter={false}
            >
                <WarehouseQuoteExtraServiceEdit

                extraServiceId={extraServiceIdEdit}
                onSaved={() => {
                    reloadTable();
                    hideEdit();
                }}
                onCancel={hideEdit}
                />
            </DefaultModal>
        ) : null}
         {showingShow ? (
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver información servicio adicional"
                showFooter={false}

            >  
                <WarehouseQuoteExtraServiceShow
                extraServiceId={extraServiceIdShow}
                onCancel={hideShow}
                />
            </DefaultModal>
                    ) : null}
        </>
    );
};

export default WarehouseQuoteExtraServiceContainer;
